var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: { zoomed: _vm.zoomed },
      on: { click: _vm.toggleZoom, mousemove: _vm.pan, mouseleave: _vm.zoomOut }
    },
    [_c("img", { ref: "image", attrs: { alt: _vm.alt, src: _vm.src } })]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }